module.exports = "/_next/static/images/a0ee7d02146cc561009c921a26e2169e-card-icon.svg";